import { CircularProgress, Stack } from "@mui/material"
import { useEffect } from "react"
import { rootStore, useStores } from "stores/root-store"
import { MainComponent, ContentWrapper, AppLoadingContainer } from "components/common-styles"
import { useParams } from "react-router-dom"
import BreadcrumbHeader from "components/common/breadcrumb-header"
import SaleOrderDeliveryInfo from "components/sale-order/details/delivery-info"
import SaleOrderProductInfo from "components/sale-order/details/product-info"
import { observer } from "mobx-react-lite"
import SaleOrderForm from "components/sale-order/dialog/sale-order-form"

const SaleOrderDetail = () => {
  const { erpOrder, id } = useParams()

  const { SaleOrderStore } = useStores()

  useEffect(() => {
    SaleOrderStore.loadDetailData(erpOrder, id)
  }, [SaleOrderStore, erpOrder, id, SaleOrderStore.forceReload])

  if (SaleOrderStore.isLoading || !SaleOrderStore.deliveryInfo) {
    return (
      <AppLoadingContainer>
        <CircularProgress size={64} />
      </AppLoadingContainer>
    )
  }

  const onEditClicked = () => {
    rootStore.setOpenForm(true)
  }

  const handleClose = () => {
    rootStore.setOpenForm(false)
  }

  const handleSave = () => {
    handleClose()
    SaleOrderStore.setForceReload()
  }

  if (rootStore.openForm) return <SaleOrderForm onSave={handleSave} onClose={handleClose} />

  return (
    <>
      <BreadcrumbHeader />
      <MainComponent component="main">
        <ContentWrapper maxWidth={"xl"}>
          <Stack spacing={2}>
            <SaleOrderDeliveryInfo onEditClicked={onEditClicked} />
            <SaleOrderProductInfo />
          </Stack>
        </ContentWrapper>
      </MainComponent>
    </>
  )
}

export default observer(SaleOrderDetail)
